import { FormControl, Validators } from '@angular/forms';

import { Expense } from '@teem/models/expense';

export class ExpenseForm {
	public uuid = new FormControl();
	public description = new FormControl('', [Validators.required]);
	public expense_date = new FormControl('', [Validators.required]);
	public expense_type = new FormControl('', [Validators.required]);
	public invoice_id = new FormControl(null);
	public cost = new FormControl(0, [Validators.required, Validators.min(0.01)]);
	public payment_type = new FormControl();
	public expense_category = new FormControl(null);
	public receipt_number = new FormControl(null);
	public vat_include = new FormControl(0);
	public invoice_title = new FormControl('');
	public total_months = new FormControl();
	public currency = new FormControl();
	public has_child_expense = new FormControl(0);
	public parent_expense_id = new FormControl();

	// public receipt_number = new FormControl('', [Validators.required, Validators.min(1)]);
    public vat_number = new FormControl(null);
    public vendor_name = new FormControl(null);
    public vat_percentage = new FormControl(null);
	public taxable_amount = new FormControl(null);
	public net_vat_amount_percent = new FormControl(0);

	public submitted = new FormControl(false);
	public edit = new FormControl(false);

	constructor(input?: Expense) {
		if (input) {

			if (input.uuid)
				this.uuid.setValue(input.uuid);

			this.description.setValue(input.description);
			this.expense_date.setValue(input.expense_date);
			this.expense_type.setValue(input.expense_type);
			this.invoice_id.setValue(input.invoice_id);
			this.expense_category.setValue(input.expense_category);
			this.cost.setValue(input.cost);
			this.payment_type.setValue(input.payment_type);
			this.receipt_number.setValue(input.receipt_number);
			this.invoice_title.setValue(input.invoice_title);
			this.vat_include.setValue(input.vat_include);
			this.total_months.setValue(input.total_months);
			this.currency.setValue(input.currency);
			this.has_child_expense.setValue(input.has_child_expense);
			this.parent_expense_id.setValue(input.parent_expense_id);

			this.receipt_number.setValue(input.receipt_number);
            this.vat_number.setValue(input.vat_number);
            this.vendor_name.setValue(input.vendor_name);
            this.vat_percentage.setValue(input.vat_percentage);
			this.taxable_amount.setValue(input.taxable_amount);
            this.net_vat_amount_percent.setValue(input.net_vat_amount_percent);
		}
	}
}
